import { REHYDRATE } from 'redux-persist'
import { createReducer, createActions } from 'reduxsauce'
import {
  initialFeedback,
  requestFeedback,
  successFeedback,
  failureFeedback
} from './utils'

const INITIAL_STATE = {
  rehydrated: false,
  config: {},
  configLoading: false,
  dashboard: {
    bannerSlides: [],
    feedback: initialFeedback(),
  },
  menuExpanded: true,
}

const { Types, Creators } = createActions(
  {
    getConfigRequest: [],
    getConfigSuccess: ['config'],
    getConfigFailure: ['error'],

    dashboardRequest: [],
    dashboardSuccess: ['config'],
    dashboardFailure: ['error'],

    toggleMenu: null,
    setMenuExpanded: ['expanded'],

  },
  { prefix: 'APP_' }
)

export const rehydrationComplete = state => ({
  ...state,
  rehydrated: true
})

export const getConfigRequest = state => ({
  ...state,
  configLoading: true
})

export const getConfigSuccess = (state, { config }) => ({
  ...state,
  config,
  configLoading: false
})

export const getConfigFailure = (state, { error }) => ({
  ...state,
  config: error,
  configLoading: false
})

export const dashboardRequest = state => ({
  ...state,
  dashboard: {
    ...state.dashboard,
    feedback: requestFeedback()
  }
})

export const dashboardSuccess = (state, { config }) => ({
  ...state,
  dashboard: {
    ...state.dashboard,
    bannerSlides: config.bannerSlides,
    feedback: successFeedback()
  }
})

export const dashboardFailure = (state, { error }) => ({
  ...state,
  dashboard: {
    ...state.dashboard,
    feedback: failureFeedback(error)
  }
})

export const toggleMenu = state => ({
  ...state,
  menuExpanded: !state.menuExpanded
})

export const setMenuExpanded = (state, { expanded }) => ({
  ...state,
  menuExpanded: expanded
})

const HANDLERS = {
  [REHYDRATE]: rehydrationComplete,
  [Types.GET_CONFIG_REQUEST]: getConfigRequest,
  [Types.GET_CONFIG_SUCCESS]: getConfigSuccess,
  [Types.GET_CONFIG_FAILURE]: getConfigFailure,

  [Types.DASHBOARD_REQUEST]: dashboardRequest,
  [Types.DASHBOARD_SUCCESS]: dashboardSuccess,
  [Types.DASHBOARD_FAILURE]: dashboardFailure,

  [Types.TOGGLE_MENU]: toggleMenu,
  [Types.SET_MENU_EXPANDED]: setMenuExpanded,
}

export const AppActionTypes = Types
export const AppActionCreators = Creators

export default createReducer(INITIAL_STATE, HANDLERS)
